import React, { Component, cloneElement } from 'react';

export class Carousel extends Component {
    state = {
        index: 0,
    }

    next = () => this.setState(({ index: prevIndex }) => ({ index: prevIndex + 1 }));
    prev = () => this.setState(({ index: prevIndex }) => ({ index: prevIndex - 1 }));

    render () {
        const { slideWith = 170, next, prev } = this;
        const { children, count } = this.props;
        const { index } = this.state;

        return children && children({
            wrapper:   (wrapper) => wrapper,
            container: (container) => cloneElement(container, {
                ref:   (node) => this.slideWidth = node && node.offsetWidth / count,
                style: {
                    transition: '300ms transform ease',
                    transform:  `translate3d(-${slideWith * index}px, 0px, 0px)`,
                },
            }),
            handleNextSlide: next,
            handlePrevSlide: prev,
            currentIndex:    index,
            slidesCount:     count,
            slidesPerPage:   5,
        });
    }
}
